module.exports = __webpack_public_path__ + "static/chocolate_flower2-4bf5955c36cab4a864f4faa76068a40c.jpg";